import { default as validateLogin } from '../LoginForm/validate';
import { default as validateRegistration } from '../RegistrationForm/validate';

export default function validate(values, props) {
    const errors = {};
    const { messages } = props;
    const { hasAccount } = values;

    if (hasAccount === 'true') {
        const { logonId, ...loginErrors } = validateLogin({ logonId: values.logonId, ...values.login }, props);
        errors.logonId = logonId;
        errors.login = loginErrors;
    } else {
        const { logonId, ...registrationErrors } = validateRegistration({ logonId: values.logonId, ...values.registration }, props);
        errors.logonId = logonId;
        errors.registration = registrationErrors;
    }

    return errors;
}
